import {
    IOneMessageJson
} from "../../../../nodeserver/structs/database.js";
import {Websocket} from "../websocket.js";
import {askWhyBanUser, handleFetchError} from "../helpers/functions.js";
import {ServerApi} from "../api.js";
import { OneDialog } from "./one-dialog.js";
import { Messages } from "./messages.js";
import { showMessageClaims } from "../models/messages/claim.js";
import { updateMessageClickEventHandler } from "../models/messages/actions/edit.js";
import { deleteActionElementFromBottomSenderNoArg, setMessagteTextAreaToDefault } from "./bottom.js";






$('html')
.on('click', '.message-dialog', async function (e) {
    e.preventDefault();
    const uid: number = $(this).data('uid');
    location.hash = `messages${uid}`;
    await Messages.Instance?.showMessagesTab(uid);
    return false;
})
.on('click', '*[data-id="#message-bans"]', async function (e) {
    await showMessageClaims(1);
})
.on('click', '.send-message', async function (this: HTMLElement) {

    if ($(".bottom-sender .update-message-area-action").length > 0) {
        updateMessageClickEventHandler();
        setMessagteTextAreaToDefault();
        return;
    }

    const textArea = $(this).parent().children('textarea'),
        isChat = textArea.hasClass('chat-message'),
        key = isChat ? 'message_0' : 'message_' + Messages.Instance!.selectedDialog!.data.user_id;

    let message: string = (textArea.val() as string).trim();
    delete localStorage[key];
    textArea.val('');
    if (message) {
        let userId = isChat ? 0 : Messages.Instance?.selectedDialog?.data?.user_id;
        let toMessage = $(".message-answer-block").data("message-id") ?? null;

        if (typeof userId != 'number') throw "Dialog not found: ";
        try {
            let res = await ServerApi.messages.sendMessage(userId, {message, answer_msg_id: toMessage});
            if (res) {
                deleteActionElementFromBottomSenderNoArg();
                setMessagteTextAreaToDefault();
            }

        } catch (e) {
            handleFetchError(e);
        }
    }
})
//Close/open chat for mobile devices
.on('click', '.close-chat-icon', Messages.showHideMessagesContainer.bind(0, false))
.on('click', '.dialog-img', async function (e) {
    if (!user_id) return;
    $(this).addClass('blocked');
    try {
        if ($(this).parents('.one-message')[0]) {
            const $msg = $(this).parents('.one-message');
            const peerId = $msg.data('chat-id') as number,
                fromUserId = $msg.data('from-id') as number;
            if (peerId <= 0) return;
            e.preventDefault();

            const nickName = $msg.find('.dialog-nickname').text();
            if (userRoles.includes('root') || userRoles.includes('moderator')) {
                const [bantime, reason] = await askWhyBanUser(nickName);
                await ServerApi.messages.banUser(peerId, true, fromUserId, bantime, reason);
            } else {
                sessionStorage[`chat_ignore_${fromUserId}`] = 1;
            }
        } else if ($(this).parents('.message-dialog')) {
            e.preventDefault();
            const $dialog = $(this).parents('.message-dialog').data('dialog') as OneDialog;
            if (!confirm(`${$dialog.banned ? 'Разблокировать' : 'Заблокировать'} пользователя ${$dialog.data.nickname}?`)) return;
            const userId = $dialog.data.user_id;
            await ServerApi.messages.banUser(userId, !$dialog.banned);
            $dialog.banned = !$dialog.banned;
        } else e.preventDefault();

    } finally {
        $(this).removeClass('blocked');
    }
})


$(document)
.on('visibilitychange', function change() {
    if (document.visibilityState !== 'visible') return;
    const selectedDialog = Messages.Instance?.dialogs?.find(e => e.messagesShown && e.selected);
    if (!selectedDialog) return;
    const lastMsg: IOneMessageJson | undefined = selectedDialog.messages[selectedDialog.messages.length - 1]?.message;
    if (lastMsg && !lastMsg.read && lastMsg.to_id == user_id && selectedDialog.canReadMessages && selectedDialog.data.unread_count > 0) {
        Websocket.Instance.readMessages(selectedDialog.data.user_id);
        selectedDialog.data.unread_count = 0;
    }
})
.on('input keydown change paste', '.message-textarea', function (e: JQuery.Event) {
    const key = $(this).hasClass('chat-message') ? 'message_0' : 'message_' + Messages.Instance!.selectedDialog!.data.user_id;
    if (e.key === 'Enter' && !e.shiftKey && !['iOS', 'Android'].includes(mobileOperatingSystem)) {
        $('.send-message').trigger('click');
        e.preventDefault();
        delete localStorage[key];
    } else {
        localStorage[key] = $(this).val();
    }
    $(this).css('height', 'auto')
        .css('height', this.scrollHeight + 4);
})

    




